import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const CancelledCustomerTableRow = ({
  id,
  createdDate,
  date,
  customerID,
  customerName,
  customerType,
  customerLocation,
  agent,
  numberOfUsers,
}) => (
  <TableRow key={id}>
    <TableCell>{createdDate}</TableCell>
    <TableCell>{date}</TableCell>
    <TableCell>{customerID}</TableCell>
    <TableCell>{customerName}</TableCell>
    <TableCell>{customerType}</TableCell>
    <TableCell>{customerLocation}</TableCell>
    <TableCell>{agent || 'No agent'}</TableCell>
    <TableCell>{numberOfUsers || 0}</TableCell>
  </TableRow>
);

export default CancelledCustomerTableRow;
